module.exports = __webpack_public_path__ + "img/eth-logo-2.45363abb.svg";